import { getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'
export default function () {
  // const contractorId = _.get(this, 'basicData.contractorId')
  return {
    MX: () => {
      return country === 'MX'
    },
    JP: () => {
      return country === 'JP'
    },
    BR: () => {
      return country === 'BR'
    },
    CR: () => {
      return country === 'CR'
    },
    CO: () => {
      return country === 'CO'
    },
    CL: () => {
      return country === 'CL'
    },
    PE: () => {
      return country === 'PE'
    }
  }
}
